import { useEffect, useState } from "react";
import { getNaturalsAdminApiBase } from "./naturalsSalonAdminApiBase";

export default function SubscriptionEndedNotice() {
  const [block, setBlock] = useState(null);

  useEffect(() => {
    let active = true;
    fetch(`${getNaturalsAdminApiBase()}/nyafaz-ep/licenses/subscription-access`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (active && data?.blocked) setBlock(data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!block) return null;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl">
        <h2 className="text-lg font-semibold text-[#1f1630]">Subscription ended</h2>
        <p className="mt-2 text-sm text-[#3b3350]">{block.message}</p>
        <p className="mt-3 text-sm text-[#1f1630]">
          Phone: {block.phone}
          <br />
          Email: {block.email}
        </p>
      </div>
    </div>
  );
}
